export function formatDate(date: Date, short: boolean = false) {
  let options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }

  if (short) {
    options = {
      month: 'short',
      day: 'numeric'
    }
  }

  return date.toLocaleDateString(undefined, options)
}

export function formatTime(date: Date) {
  const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit'
  }

  return date.toLocaleTimeString(undefined, options)
}

export function dateAsNumbers(date: Date) {
  const month =
    date.getMonth() < 10 ? '0' + (date.getMonth() + 1) : date.getMonth()
  const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const year = date.getFullYear()

  return month + '-' + day + '-' + year
}

export function shortDate(date: Date) {
  let formattedDate = date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })

  const splitDate = formattedDate.split(' ')

  if (splitDate[0].length > 3) {
    splitDate[0] = splitDate[0].substring(0, 3)
  }

  formattedDate = ''

  for (const i in splitDate) {
    if (parseInt(i) < splitDate.length - 1) {
      formattedDate += splitDate[i] + ' '
    } else {
      formattedDate += splitDate[i]
    }
  }

  return formattedDate
}
